const LAYER_FILTER_TRANSITION_DURATION_MS = 225;
const layerTransitionCls = "_61l1bg95bc";
const layerCls = "_61l47orao";
const buttonCls = "_61bla6y8u";
const linkCls = "_61l176bf3g";
const vignetteWrapperCls = "_61v138xrku";
const vignetteBackgroundCls = "_61vaf43p5";
const vignetteCls = "_61v1s7fqjb";
const vignetteTextWrapperCls = "_61v176k1b";
const vignetteTextCls = "_61v1qjfcm9";
const labelCls = "_61l1un93si";
const loadingEllipsisCls = "_61l4llb8h";

export { LAYER_FILTER_TRANSITION_DURATION_MS, buttonCls, labelCls, layerCls, layerTransitionCls, linkCls, loadingEllipsisCls, vignetteBackgroundCls, vignetteCls, vignetteTextCls, vignetteTextWrapperCls, vignetteWrapperCls };
import "./atom.layer.style.linaria.module.css";
//# sourceMappingURL=atom.layer.style.js.map
